<template>
  <consulta ref="modal" :columns="columns" :process="process"
            :custom-actions="actions" id="consultar-tarefa" :titulo="titulo" :stopLoad="true">
    <template #filtros>
      <filtrar-consulta class="w-100" :options="opcoesConsulta" :dto="filtros"></filtrar-consulta>
    </template>
    <template #row="{ row }">
      <tr>
        <td width="50px" class="text-center">
          <router-link :to="{ name: 'tarefa', params:{id : row.id} }" class="icon" target="_blank" @click.native="$event.stopImmediatePropagation()">
            <i class="fas fa-external-link-alt"></i>
          </router-link>
        </td>


        <td width="140px" class="pointer icon" @click="select(row)">
          <a>{{ row.codigo | inteiro }}</a>
        </td>
        <td width="140px">{{ row.tipo }}</td>
        <td width="140px">{{ row.cadastro | datahora }}</td>
        <td width="140px">{{ row.encerramento | datahora }}</td>
        <td width="50px" class="text-center">
          <v-button :run="duplicar" :params="[row.id]" :button="false" :popover="true" class="icon"
                    position="dropleft">
            <i class="fal fa-copy" title="Duplicar"></i>
          </v-button>
        </td>
      </tr>

    </template>
  </consulta>
</template>

<script>

import Consulta from "@/components/Consultas/Consulta.vue";
import Utils from "@/commons/Utils";
import FrontBusiness from "@/business/FrontBusiness";
import DetalhesTarefa from "@/views/Processos/DetalhesTarefa.vue";
import TarefaBusiness from "@/business/tarefa/TarefaBusiness";
import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness";
import EtapaBusiness from "@/business/crud/EtapaBusiness";
import ProtocoloBusiness from "@/business/protocolo/ProtocoloBusiness";
import FiltrarConsulta from "@/components/Consultas/components/FiltrarConsulta.vue";

export default {
  name: "ConsultarTarefa",
  components: {FiltrarConsulta, Consulta},
  data() {
    return {
      opcoesConsulta: [],
      filtros : {
        filtros: []
      },
      listas: {
        tiposServico: [],
        etapas: []
      },
    }
  },
  async mounted(){
    await TipoServicoBusiness.getByDominioSimples('PERSONALIZADO').then(l => this.listas.tiposServico = Object.freeze(Utils.orderBy(l, 'nome')));
    await EtapaBusiness.getByDominioSimples('PERSONALIZADO').then(l => this.listas.etapas = Object.freeze(Utils.orderBy(l, 'nome')));

    let opcoes = [];
    opcoes.push({id: 'tipo_servico_id', nome: 'Tipo de Tarefa', type: 'list', options: this.listas.tiposServico});
    opcoes.push({id: 'descricao', nome: 'Descrição', type: 'text'});
    opcoes.push({id: 'cadastro', nome: 'Data Cadastro', type: 'date'});
    opcoes.push({id: 'encerramento', nome: 'Data Encerramento', type: 'date'});
    opcoes.push({id: 'codigo', nome: 'Código', type: 'number'});
    opcoes.push({id: 'status', nome: 'Status/Situação', type: 'list', options: ProtocoloBusiness.getStatus()});
    opcoes.push({id: 'etapa_id', nome: 'Etapa Atual', type: 'list', options: this.listas.etapas})

    this.opcoesConsulta = Utils.orderBy(opcoes, 'nome');
  },

  methods:{

    close(){
      FrontBusiness.closeModal();
    },

    select(item) {
      FrontBusiness.closeModal(item);
    },

    async process(sort_by, sort_dir, page_length, page_number){
      let filtros = [...this.filtros?.filtros].filter(e => e.id);
      return TarefaBusiness.paginationV2(sort_by, sort_dir, page_number, page_length, {filtros})
          .then(result => ({rows : result.pagina, total: result.quantidade}));
    },

    novo(){
      FrontBusiness.openModal(DetalhesTarefa);
    },

    executeLoad(){
      this.armazenarFiltro();
      this.$refs.modal.load();
    },

    remover(idx, lista) {
      this.$nextTick(() => {
        this.filtros[lista].splice(idx, 1);
      });
    },

    async duplicar(id){
      let clone = await TarefaBusiness.clonar(id);
      if (clone) {
        FrontBusiness.redirect(`tarefa/${clone.id}/geral`);
      }
    },

    selecionarTodos(limpar = false) {
      this.marcados = [];
      this.$refs?.modal?.$refs?.paginator?.rows.forEach(r => {
        let input = document.getElementById(`check-${r.id}`)
        input.checked = !limpar;
        if (!limpar) this.marcados.push(r)
      })
    },

    selectItem(item) {
      let index = this.marcados.findIndex(e => e.id === item.id);
      if (index >= 0) {
        this.marcados.splice(index, 1)
      } else {
        this.marcados.push(item)
      }
    },

  },

  computed:{
    titulo(){
      return 'Consultar Tarefa';
    },

    columns(){
      let columns = [];

      columns.push(
          {label: '', field: 'id', headerClass: 'column__botao', sortable: false, name: 'id'},
          {label:  'Código', field: 't.codigo', name: 'codigo'},
          {label:  'Tipo', field: 'ts.nome', name: 'tipo'},
          {label:  'Cadastro', field: 't.cadastro', name: 'cadastro'},
          {label:  'Encerramento', field: 't.encerramento', name: 'encerramento'},
          {label: '', field: 'id', headerClass: 'column__botao', sortable: false, name: 'id'}
      );

      return columns;
    },

    actions() {
      let actions = [];
      actions.push({
        class: 'at-options',
        icon: 'far fa-plus-square mr-1',
        label: 'Nova Tarefa',
        action: this.novo
      });
      return actions;
    },
  }
}
</script>

<style>

</style>
